import { sync } from 'vuex-router-sync'
import Vue from 'vue'
import ElementUI from 'element-ui'
import ElementUIDictionary from 'element-ui/lib/locale/lang/en'
import Root from './Root'
import Vuex from 'vuex';
import vuexI18n from 'vuex-i18n';
import translations from '../lang';

import validationDictinary from '../lang/validations';
import moment from 'moment'

import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';

// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg'


import vSelect from 'vue-select';

import ToggleButton from 'vue-js-toggle-button'

const Lang = 'en';

/**
* This is the Vuex store and it is
* avaible to all your components
*/
import store from './store'

/**
* This is the Router
*/
import router from './router'


/**
* $http plugin based on axios
*/
import httpPlugin from './plugins/http'

/**
* eventbus plugin
*/
import eventbus from './plugins/eventbus'


/**
* jQuery and Bootstrap includes
*/
require('./includes')

/**
* Vue Mixins
*/
require('./components/mixins/loader.js')
require('./components/mixins/validationErrors.js')

/**
* Make $http avaible to all components
* Send store and router to httpPlugin (injection)
*/
Vue.use(httpPlugin, { store, router })

import { apiUrl } from './config'
window.baseUrl = apiUrl;
/**
* Make $bus avaible to all components
*/
Vue.use(eventbus)

// Effortlessly keep vue-router and vuex store in sync.
sync(store, router) // https://github.com/vuejs/vuex-router-sync/tree/next


// initialize the vuex store using the vuex module. note that you can change the
//  name of the module if you wish
const hf = new Vuex.Store({
	modules: {
		i18n: vuexI18n.store
	}
});
// Navigation guard to add/remove class based on the route
router.beforeEach((to, from, next) => {
  if (to.name === 'userportal' || to.name === 'Enduserportal' || to.name === 'Enduserportal2') {
    document.body.classList.add('userportallayout');
  } else {
    document.body.classList.remove('userportallayout');
  }
  next(); 
});
Vue.use(ToggleButton);
Vue.use(VueFroala);

// Register a global custom directive called v-focus
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})

  var numeral = require("numeral");

  Vue.filter("formatNumber", function (value) {
    return numeral(value).format("0,0"); // displaying other groupings/separators is possible, look at the docs
  });
  
/**
* External Libraries used along with Vue
*/
Vue.use(vuexI18n.plugin, hf);
Vue.i18n.add('en', translations.en);
// Vue.i18n.add('de', translationsDe);
Vue.i18n.set(Lang);
moment().locale(Lang);

Vue.use(ElementUI, { locale:ElementUIDictionary });

Vue.use(VeeValidate,{ locale: Lang, events: 'blur' });

// Back-compat: `updateDictionary` was removed in vee-validate 2.1+ (installed 2.2.x) in favour
// of `localize`, which accepts the same `{ <locale>: { custom|messages|attributes } }` shape.
// Many components still call `this.$validator.updateDictionary(dict)`. `this.$validator` is a
// ScopedValidator (not the base Validator, and it isn't exported), so we alias the method onto
// its prototype the first time a component exposes a validator instead of editing every call site.
if (Validator && Validator.prototype && typeof Validator.prototype.updateDictionary !== 'function') {
  Validator.prototype.updateDictionary = function (dictionary) {
    return this.localize(dictionary);
  };
}
Vue.mixin({
  created() {
    var validator = this.$validator;
    if (validator && typeof validator.updateDictionary !== 'function') {
      var proto = Object.getPrototypeOf(validator);
      if (proto && typeof proto.updateDictionary !== 'function') {
        proto.updateDictionary = function (dictionary) {
          return this.localize(dictionary);
        };
      }
    }
  }
});

// infinite scroll
var infiniteScroll =  require('vue-infinite-scroll');
Vue.use(infiniteScroll)

Vue.config.lang = Lang;
// Validator.updateDictionary(validationDictinary);

Vue.component('v-select', vSelect);

var VueTruncate = require('vue-truncate-filter')
Vue.use(VueTruncate)

Vue.filter('DateConvertTo24Hours', function(data) {
  if (data) {
    const onlyData = moment(String(data)).format('DD MMM YYYY')
    return onlyData + ',' + ' ' +moment(data).format("HH:mm");
  }
});

Vue.filter('removeUnderscoreAddSpace', function(value) {
  if (value) {
    return value.replace(/_/g, ' ')
  }
});
document.documentElement.style.setProperty('--background-color', '#2b303b');
    document.documentElement.style.setProperty('--sub-menus', '#272b35');
    document.documentElement.style.setProperty('--button-colors', '#48b0f7');
// Vue.component('campaignCard', require('./components/sub_component/campaignCard.vue'));
Vue.component('bulkCampaignCard', require('./components/sub_component/bulkCampaignCard.vue'));
Vue.component('educationCard', require('./components/sub_component/educationCard.vue'));
Vue.component('scenarioCard', require('./components/sub_component/scenarioCard.vue'));
Vue.component('editCampaignModal', require('./components/sub_component/editCampaignModal.vue'));
Vue.component('campaignScheduleCard', require('./components/sub_component/campaignScheduleCard.vue'));
Vue.component('nextButtonCard', require('./components/sub_component/nextButtonCard.vue'));
Vue.component('vcroFormulaInfo', require('./app/vcro/components/VcroFormulaInfo.vue'));

/* eslint-disable no-new */
new Vue({
    store, // injects the Store into all components
    router, // make Router work with the application
    el: '#app',
    render: h => h(Root),
});



// WEBPACK FOOTER //
// ./src/main.js